













import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import AsiTextarea from "@/components/common/AsiTextarea";
import User from "@/models/user/User";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import {ValidationRule} from "@/declarations/ValidationRule";
import UserRules from "@/models/user/UserRules";

@Component({
	components: {AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class UserUpdateDialogUsername extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public user!: User;

	private username: string | null = null;

	// noinspection JSMethodCanBeStatic
	private get usernameRules(): ValidationRule[] {
		return UserRules.usernameRules;
	}

	public created(): void {
		this.username = this.user.username;
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		this.username = this.user.username;
		return event;
	}

	@Watch('user', {deep: true})
	private onUserChanged(): void {
		this.username = this.user.username;
	}

	private requestSave(event: Event): void {
		if (this.username === null) return;

		this.loading = true;
		this.$userService.updateUsername(this.user.id, this.username)
			.then(() => this.save(event))
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.updateError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
